import React, {useState, useEffect} from 'react';
import {Form, Button, Alert, Col} from 'react-bootstrap';
import {Formik} from 'formik';
import {Link} from 'react-router-dom';
//Redirect
import axios from 'axios';
import {apiUrl} from '../../util/Api';
import {clearAuthentication} from '../../util/Auth';

import {useDispatch} from 'react-redux';
import {clearUserStore} from '../../app/slices/UserSlice';

//import {string, object} from 'yup';
import * as Yup from 'yup';

const validationSchema = Yup.object({
  email: Yup.string().email('please enter a valid email').required('email is required')
});

const ForgotPassword = () => {
  const [errors, setErrors] = useState([]);
  const [successMsgs, setSuccessMsgs] = useState([])
  const [showForm, setShowForm] = useState(true);

  //let history = useHistory();

  const dispatch = useDispatch();

  useEffect(()=>{
    //console.log('in recover form');
    //clear user ?
    clearAuthentication();
    dispatch(clearUserStore());
    document.title = `reconify forgot password`;
  },[dispatch])

  const submitForm = (values, actions) => {
    setErrors([]);
    setSuccessMsgs([]);

    axios.post(apiUrl + '/recover/recoverpass', values, {withCredentials: true})
    .then((res) => {
      if(res.data.status === "ok") {
        let successes = []
        successes.push('If an account exists, an email will be sent with recovery information.');
        successes.push('Please check your spam folder.')
        setSuccessMsgs(successes);
        setShowForm(false)
      }
      else {
        //console.log('an error was returned');
        //display errors
        clearAuthentication();
        dispatch(clearUserStore());

        let errorMsgs = [];
        res.data.errors.forEach((error, i) => {
          switch (error) {
            case 'email-missing':
              errorMsgs.push('Please enter an email.');
              break;
            default:
              errorMsgs.push('There was an error processing this request.');
          }
        });
        setErrors(errorMsgs);
      }
    })
    .catch((err) => {
      //console.error(err);
      //console.log('something went wrong');
      clearAuthentication();
      dispatch(clearUserStore());
      setErrors(['An error occured. Try again later.']);
    });
  }

  //check if logged in
  //<Redirect to="/"/>
  return (
    <Col xs={10} sm={8} md={6} className="public-component">
      <h3>Forgot Password</h3>
      <p>
        Use the form below to reset your password.
      </p>
      {
        errors.length > 0 ? (
          <Alert variant='danger'>
          {errors.map((err, i) => (<div key={'err.' + i}>{err}</div>))}
          </Alert>
        ) : (null)
      }
      {
        successMsgs.length > 0 ? (
          <Alert variant='info'>
          {successMsgs.map((msg, i) => (<div key={'msg.' + i}>{msg}</div>))}
          </Alert>
        ) : (null)
      }
      { showForm ? (

        <Formik validationSchema={validationSchema}
          onSubmit={submitForm}
          initialValues={{email:''}}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            touched,
            isValid,
            errors
          }) => (
            <Form noValidate onSubmit={handleSubmit} className='col-md-7 col-sm-8'>
              <Form.Group controlId='login-email' className='mb-3'>
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" placeholder="email"
                  name="email" value={values.email} onChange={handleChange}
                  isInvalid={touched.email && errors.email}
                />
                <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
              </Form.Group>

              <Button variant="primary" type="submit">Recover</Button>
            </Form>
          )}
        </Formik>

      ) : (null)}

      <div className='mt-3 text-center'>
      <Link to='/login'><small>Return to login</small></Link>
      </div>
    </Col>
  );
}


export default ForgotPassword;
